import { defineMessages } from "react-intl";

export const messages = defineMessages({
  webhookStatus: {
    id: "1+M/52",
    defaultMessage: "Webhook Status",
    description: "section header",
  },
  webhookActive: {
    id: "W+x5ZI",
    defaultMessage: "Webhook is active",
    description: "webhooks active label",
  },
  webhookActiveDescription: {
    id: "IBCBi1",
    defaultMessage:
      "If you want to disable this webhook please uncheck the box below.",
    description: "webhook active description",
  },
});
